import { createSlice } from '@reduxjs/toolkit'
export interface IUserViewState {
    pagination: {
        itemsPerPage: number
        currentPage: number
        total: number
    }
    searchValue: string | null
    filters?: any
    sort?: string
    projection?: any
    needPopulate: boolean
    populates?: any
    uploadAvatarModal: boolean
}

const initialState: IUserViewState = {
    pagination: {
        itemsPerPage: 10,
        currentPage: 1,
        total: 0
    },
    searchValue: null,
    filters: {},
    sort: '-createdAt',
    projection: [],
    needPopulate: true,
    populates: [],
    uploadAvatarModal: false
}

const userViewSlice = createSlice({
    name: 'ui/user',
    initialState,
    reducers: {
        setUploadAvatarModal(state, action) {
            state.uploadAvatarModal = action.payload
        },
        onChangePagination(state, acion) {
            state.pagination = { ...state.pagination, ...acion.payload }
        },
        onChangeSearch(state, action) {
            state.searchValue = action.payload
        },
        onChangeTotal(state, action) {
            state.pagination = { ...state.pagination, total: action.payload }
        }
    }
})

export const userActions = userViewSlice.actions
export default userViewSlice.reducer
